<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import ACL from '../../../../domain/acl/tmp-acl'
  import { mapState, mapGetters } from 'vuex'
  import MenuItem from '../MenuItem'

export default{
    name: 'MenuLogs',
    components: {MenuItem},
    data () {
      return {
        open: false
      }
    },
    computed: {
      ...mapState({
        menuOpen: state => state.app.menuOpen
      }),
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="fa fa-server icon text-white"></i>
      <span>Comunicação DETRO</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Tasks</span></a></li>
      <menu-item
        :to="{name: 'detro.tasks.list'}"
        label="Tasks"
        icon=""
        icon-color-class=""
        :show="ACL.check('exibir_tasks', currentUser.id)"
      ></menu-item>
      
      <menu-item
        :to="{name: 'logs'}"
        label="Logs"
        icon=""
        icon-color-class=""
        :show="ACL.check('exibir_logs', currentUser.id)"
      ></menu-item>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// Logs.vue?5bd76c63